import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { validateLogin } from "../../services/validate-login";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { getFormattedDate } from "../../utils/dateFormat";
import { loanSearchService, select2Service } from "../../services/ondcService";
import { v4 as uuidv4 } from "uuid";
import Loader from "../../components/common/Loader";

function Form() {
  const [accountAggregator, setAccountAggregator] = useState("finvu");
  const [finvuConsent, setFinvuConsent] = useState(false);
  const [formIsComplete, setFormIsComplete] = useState(false);   

  const [loading, setLoading] = useState(false); // start false (page load)
  const navigate = useNavigate();

  const wait = (ms: number | undefined) => new Promise((resolve) => setTimeout(resolve, ms));
  
  useEffect(() => {
    async function getStep() {
      if(Number(localStorage.getItem("step")) >= 4){} else{ navigate("/personal-loan") }
    }
    getStep();
  }, []);

  const onClickEvent = async () => {
    try {
      setLoading(true); // show loader
      localStorage.setItem("step", "5")
      // wait for 5 seconds before navigating
      await new Promise((resolve) => setTimeout(resolve, 5000));
      navigate("/offer-by-lenders");
    } catch (err) {
      console.error("Error fetching offers:", err);
    } finally {
      setLoading(false); // hide loader
    }
  };

  if (loading) {
    // full-screen loader while API is fetching
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#f5f9ff] px-4">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Left side Image (fixed) */}
        <div className="basis-full md:basis-2/5 flex items-center justify-center p-6 bg-gray-50 md:h-[calc(100vh-100px)] md:sticky md:top-0">
          <img
            src="svg/img3.svg"
            alt="Working professional"
            className="w-full max-w-xs md:max-w-none object-contain"
          />
        </div>

        {/* Right side Form (scrollable) */}
        <div className="basis-full md:basis-3/5 flex flex-col p-8 bg-white relative md:h-[calc(100vh-100px)] md:overflow-y-auto">
          {/* Step Number */}
          <div className="absolute top-4 right-4 bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            Step 5
          </div>
          <div className="flex-1 overflow-y-auto">
            <h2 className="text-xl font-semibold mb-6">
              PERSONAL LOAN APPLICATION
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Please review Terms of Use & Privacy Policy
            </p>

            <div className="space-y-6">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="finvuConsent"
                  checked={finvuConsent}
                  onChange={(e) => {
                      setFinvuConsent(e.target.checked)
                      setFormIsComplete(e.target.checked)
                    }}
                  className="form-checkbox text-blue-600"
                />
                <span className="text-gray-800">I agree and approve my consent to proceed as per the above shared clauses in <a href="https://www.hindustanloans.com/terms-of-use" target="_blank"><u>‘Terms of Use’</u></a> and <a href="https://www.hindustanloans.com/privacy-policy" target="_blank"><u>‘Privacy Policy’</u></a></span>
              </label>
            </div>
          </div>

          {/* Buttons */}
          <div className="mt-6 flex gap-4">
            <button
              className="flex-1 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2"
              onClick={() => navigate("/employment-details")}
            >
              <ArrowLeft size={18} /> Back
            </button>

            <button
              className={`flex-1 px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
                ${formIsComplete
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-gray-400 cursor-not-allowed"}`}
              onClick={onClickEvent}
              disabled={!formIsComplete}
            >
              Next <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default function Step4TermNCondition() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, [navigate]);

  return (
    <div className="flex flex-col h-screen overflow-y-auto">
      <div className="flex-shrink-0">
        <Header title="" />
      </div>

      {/* Main Content scrollable */}
      <main className="flex-1 overflow-y-auto">
          <Form />
      </main>
    </div>
  );
}
